import { createFileRoute } from '@tanstack/react-router';
import { PaginaDePagamento } from '@/features/pagamentos/componentes/PaginaDePagamento';

/**
 * Página pública de pagamento (spec 013, ADR-0017): fora do layout da equipe e sem `/me`; o token
 * do link é a credencial. CSP própria no nginx (`docker/seguranca-pagar.conf`).
 */
export const Route = createFileRoute('/pagar/$token')({
  component: Pagina,
});

function Pagina() {
  const { token } = Route.useParams();
  return <PaginaDePagamento key={token} token={token} />;
}
